/*
  中面テンプレートDL（download-template）リスト表示用の絞り込み。
  <download-template-filter> 内の input の値で、同じセクション内の行（[data-filter-item]）の
  見出しテキストを部分一致フィルタする（全タブ横断・リアルタイム）。
  - 比較は NFKC 正規化＋小文字化＋カタカナ→ひらがな変換で行う（「イヌ」でも「いぬ」に一致）。
  - 各タブのボタンに一致件数（[data-tab-count]）を表示し、一致0件のパネルには
    「該当なし」文言（[data-filter-empty]）を出す。
*/
if (!customElements.get('download-template-filter')) {
  class DownloadTemplateFilter extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.countEl = this.querySelector('[data-filter-count]');
      this.root = this.closest('.download-template');
      if (!this.input || !this.root) return;

      this.rows = Array.from(this.root.querySelectorAll('[data-filter-item]'));
      this.rows.forEach((row) => {
        const title = row.querySelector('.download-template__row-title');
        row.dataset.filterKey = DownloadTemplateFilter.normalize(title ? title.textContent : '');
      });
      this.panels = Array.from(this.root.querySelectorAll('[role="tabpanel"]'));

      this.input.addEventListener('input', () => this.apply());
      this.input.addEventListener('search', () => this.apply());
      if (this.input.value) this.apply();
    }

    static normalize(text) {
      return String(text)
        .normalize('NFKC')
        .toLowerCase()
        .replace(/[ァ-ヶ]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0x60))
        .replace(/\s+/g, '');
    }

    apply() {
      const query = DownloadTemplateFilter.normalize(this.input.value.trim());
      let total = 0;
      this.rows.forEach((row) => {
        const hit = query === '' || row.dataset.filterKey.includes(query);
        row.hidden = !hit;
        if (hit) total += 1;
      });

      this.panels.forEach((panel) => {
        const visible = panel.querySelectorAll('[data-filter-item]:not([hidden])').length;
        const empty = panel.querySelector('[data-filter-empty]');
        if (empty) empty.hidden = !(query !== '' && visible === 0);
        const count = this.root.querySelector(`[aria-controls="${panel.id}"] [data-tab-count]`);
        if (count) {
          count.textContent = query !== '' ? `（${visible}）` : '';
          count.hidden = query === '';
        }
      });

      if (this.countEl) {
        this.countEl.textContent = query !== '' ? `${total}件が該当` : '';
        this.countEl.hidden = query === '';
      }
    }
  }
  customElements.define('download-template-filter', DownloadTemplateFilter);
}
